import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from '../components/header'
import Menu from '../components/menu'
import { staticContentsImagePath as BASE_IMAGE_PATH } from '../configs/const';

class MaintananceHome extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isMaintanance: false
        };
    }

    updateMaintanence(status) {
        this.setState({ isMaintanance: status })
    }

    render() {
        let accData = JSON.parse(localStorage.getItem("accountData"));
        return (
            <body>
                <Header notify={this.props.notify} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateMaintanence={(status) => { this.updateMaintanence(status) }} />
                <div className={`full-wrap mar-top100 footerpd ${(!!accData && Object.keys(accData).length > 0) ? '' : 'mar-top100-login mar-bottom0'}`}>
                    <Menu history={this.props.history} isMaintanance={this.state.isMaintanance} />
                    <div className="col-center1 markets">
                        <div className="w-100 text-center pb-5" style={{ background: "#fff" }}>
                            <img alt="Under Maintanence" className="" src={BASE_IMAGE_PATH + "casino/banner/images/undermaintenance.png"} ></img>
                            <div className="alert alert-warning f-18 w-75 mt-1 mx-auto" role="alert">कृपया हमारा सिस्टम मेंटेनन्स में है| हमारी सिस्टम का मेंटेनन्स ख़तम नहीं होता तब तक आप हमारी फ्री गेम्स का मजा ले सकते हो! फ्री गेम्स की धनराशि आपकी हारजीत में असर नहीं करेगी! धन्यवाद ! </div>
                        </div>
                    </div>
                </div>
            </body>
        )
    }
}

function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(MaintananceHome);